<template>
    <div class="yh-page">
        <el-card v-loading="loading" :element-loading-text="loadingText">
            <el-row slot="header" type="flex" justify="start" align="middle" class="p-3" :gutter="10">
                <el-col :span="14">
                    <span>
                        <el-button type="primary" size="small" icon="el-icon-back"
                            @click="() => { this.$router.go(-1) }">返回</el-button>
                        <el-button type="success" size="small" icon="el-icon-check"
                            v-if="['1',].indexOf(supplement.status) !== -1 && action == 'check'"
                            @click="handleCheck(true)">
                            <label>同意</label>
                        </el-button>
                        <el-button type="warning" size="small" icon="el-icon-close"
                            v-if="['1',].indexOf(supplement.status) !== -1 && action == 'check'"
                            @click="handleCheck(false)">
                            <label>拒绝</label>
                        </el-button>
                    </span>
                </el-col>
            </el-row>

            <el-collapse v-model="activeNames">
                <el-collapse-item title="清单概况" name="1">
                    <el-row class="py-1">
                        <el-col :span="2" :offset="1" class="font-weight-bold">客户名称</el-col>
                        <el-col :span="8">{{ supplement.name }}</el-col>
                        <el-col :span="2" class="font-weight-bold">创建时间</el-col>
                        <el-col :span="9">{{ supplement.create_time | parseTime }}</el-col>
                    </el-row>
                    <el-row class="py-1">
                        <el-col :span="2" :offset="1" class="font-weight-bold">签署状态</el-col>
                        <el-col :span="8">
                            <el-tag size="small" :type="supplement.sign_status === '1' ? 'success' : 'danger'">
                                {{ supplement.sign_status_name }}
                            </el-tag>
                        </el-col>
                        <el-col :span="2" class="font-weight-bold">状态</el-col>
                        <el-col :span="9">
                            <span class="badge mr-1" :class="getStatusBadge(supplement.status)">
                                {{ supplement.status_name }}
                            </span>
                        </el-col>
                    </el-row>
                </el-collapse-item>
                <el-collapse-item title="相关文书" name="2">
                    <el-row class="py-1">
                        <el-col>
                            <el-button type="primary" @click="handleExportCommitment">制作文书</el-button>
                        </el-col>
                        <el-col>
                            <el-table :data="attachments" style="width: 100%">
                                <el-table-column label="原文件">
                                    <template slot-scope="scope">
                                        <el-link type="primary" @click="previewPdf(scope.row)">{{ scope.row.name
                                        }}</el-link>
                                    </template>
                                </el-table-column>
                                <el-table-column label="签署文件">
                                    <template slot-scope="scope">
                                        <el-link type="primary" @click="previewPdf(scope.row.child_obj)">{{
                                            scope.row.child_obj.name }}</el-link>
                                    </template>
                                </el-table-column>
                                <el-table-column min-width="15%" label="文件大小">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.size | formatSize }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column min-width="20%" label="创建日期">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.create_time | parseTime }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column property="status" label="签署状态" min-width="20%">
                                    <template slot-scope="scope">
                                        <el-tooltip class="item" effect="dark" :content=getSignTooltip(scope.row) placement="top">
                                            <span>{{ scope.row.status === 2 ? '已签署' :
                                                scope.row.status === 1 ? '签署中' :
                                                    scope.row.status === 0 ? '未签署' : '' }}</span>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                                <!-- 按钮组 -->
                                <el-table-column align="left" label="操作" min-width="25%">
                                    <template slot-scope="scope">
                                        <el-tooltip effect="light" content="下载原文件" placement="top-start">
                                            <el-button type="text" @click="download(scope.row)"><i
                                                    class="el-icon-download"></i></el-button>
                                        </el-tooltip>
                                        <el-tooltip effect="light" content="下载已签署文件" placement="top-start">
                                            <el-button type="text" @click="download(scope.row.child_obj)"><i
                                                    class="el-icon-download"></i></el-button>
                                        </el-tooltip>
                                        <el-tooltip effect="light" content="发送签署" placement="top-start">
                                            <el-button type="text"
                                                v-show="canSend(scope.row) && [1, 2].indexOf(scope.row.status) == -1"
                                                @click="showDialog(scope.row)"><i class="el-icon-s-claim"></i></el-button>
                                        </el-tooltip>
                                        <el-tooltip effect="light" content="撤销" placement="top-start">
                                            <el-button type="text" v-show="(scope.row.file_sign.length != 0) && [0, 1].indexOf(scope.row.file_sign[0].sign_flow_status) !== -1"
                                                @click="handleRevokeSign(scope.row.file_sign[0].id)"><i class="el-icon-s-release"></i></el-button>
                                        </el-tooltip>
                                        <el-tooltip effect="light" content="签署链接" placement="top-start">
                                            <el-button type="text" v-show="(scope.row.file_sign.length != 0) && (scope.row.file_sign[0].receiver)"
                                                @click="signUrl(scope.row.file_sign[0].id)"><i
                                                    class="el-icon-link"></i></el-button>
                                        </el-tooltip>
                                        <el-tooltip effect="light" content="催签" placement="top-start">
                                            <el-button type="text" v-show="(scope.row.file_sign.length != 0) && (scope.row.file_sign[0].receiver)"
                                                @click="handleUrgeSign(scope.row.file_sign[0].id)"><i
                                                    class="el-icon-alarm-clock"></i></el-button>
                                        </el-tooltip>
                                        <el-tooltip effect="light" content="上传已签署" placement="top-start"
                                            v-show="!scope.row.child">
                                            <el-upload class="margin-change" action="" :auto-upload=true
                                                :http-request="handleUploadFile" :show-file-list="false"
                                                :file-list="file_list" :limit="1">
                                                <el-button type="text" @click="() => { file_id = scope.row.id }"><i
                                                        class="el-icon-upload2"></i></el-button>
                                            </el-upload>
                                        </el-tooltip>
                                        <el-tooltip effect="light" placement="top-start" content="删除">
                                            <el-button type="text" v-show="scope.row.status === null"
                                                @click="handleDelete(scope.row)">
                                                <i class="el-icon-delete"></i>
                                            </el-button>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-col>
                    </el-row>
                </el-collapse-item>
                <el-collapse-item title="文件清单" name="3">
                    <table width="100%" :border="1" bordercolor="#DADEDB">
                        <tbody>
                            <tr style="background-color: #DADEDB; text-align: center;">
                                <th width="20%">名称</th>
                                <th width="20%">文件类型</th>
                                <th width="20%">文件状态</th>
                                <th width="20%">上传时间</th>
                                <th width="20%">操作</th>
                            </tr>
                            <template v-for="supplement_relation in supplement.supplement_relation_list">
                                <tr v-for="(file, file_index) in supplement_relation.file_list" :key="file.id"
                                    style="height: 50px;">
                                    <td width="20%" v-if="file_index === 0" :rowspan="supplement_relation.file_list.length">
                                        <span>{{ supplement_relation.name }}</span>
                                    </td>
                                    <td width="20%">
                                        <span>{{ file.file_type.value }}</span>
                                    </td>
                                    <td width="20%">
                                        <span>{{ file.file ? '已上传' : '未上传' }}</span>
                                    </td>
                                    <td width="20%">
                                        <span>{{ file.file ? parseTime(file.file.create_time, '{y}-{m}-{d} {h}:{i}:{s}') : '' }}</span>
                                    </td>
                                    <td width="20%">
                                        <el-tooltip v-if="file.file === null && supplement.status === '0'" effect="light" content="上传"
                                            placement="top-start">
                                            <el-button type="text" class="pr-1"
                                                @click="handleUpload(supplement_relation, file)">
                                                <i class="el-icon-upload"></i>
                                            </el-button>
                                        </el-tooltip>
                                        <el-tooltip v-if="file.file !== null && supplement.status === '0'" effect="light" content="删除" placement="top-start">
                                            <el-button type="text" class="pr-1"
                                                @click="handleDeleteFile(file)">
                                                <i class="el-icon-delete"></i>
                                            </el-button>
                                        </el-tooltip>
                                        <el-tooltip v-if="file.file !== null" class="item" effect="light" content="下载" placement="top-start">
                                            <el-button type="text" class="pr-1"
                                                @click="handleDownload(file.file)">
                                                <i class="el-icon-download"></i>
                                            </el-button>
                                        </el-tooltip>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </el-collapse-item>
            </el-collapse>
        </el-card>

        <el-dialog title="签署人选择" :visible.sync="dialogFormVisible" :show-close="false">
            <el-form label-position="left" label-width="150px">
                <el-form-item label="签署方类型">
                    <el-radio-group v-model="signer_type">
                        <el-radio :label="0">个人</el-radio>
                        <el-radio :label="1">公司</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="签署人">
                    <el-select v-model="signer_mobile" filterable placeholder="请选择签署人">
                        <el-option v-for="contact in contacts" :key="contact.id"
                            :label="contact.name + '(' + contact.mobile + ')'" :value="contact.mobile"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="signer_type === 1" label="签署方公司名称">
                    <el-select placeholder="请选择签署方公司名称" filterable remote reserve-keyword :loading="org_loading"
                                :remote-method="remoteSearch" v-model="signer_org_name" class="w-75">
                        <el-option v-for="org in org_list" :key="org.id" :label="org.name" :value="org.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCancelSend">取 消</el-button>
                <el-button :disabled="signer_mobile === ''" type="primary" @click="sendSign">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :title="pdfname" :visible.sync="previewVisible">
            <vue-pdf-preview :url="pdfUrl"></vue-pdf-preview>
        </el-dialog>
        <upload-dialog ref="upload" :file-type-list="file_type_list" :object-name="object_name" :object-id="object_id"
            :default-issue-date.sync="default_issue_date" :default-expire-date.sync="default_expire_date"
            @uploaded="loadData" @appended="handleAppended">
        </upload-dialog>
    </div>
</template>
  
<script>
import { fetchSupplementDetail, exportSupplementCommitment, deleteSupplementRelationFile, checkSupplement } from '@/api/supplement'
import { fetchAllContacts } from '@/api/contact'
import { fetchInsuranceObjectFileList } from '@/api/common'
import { formatCurrency, formatSize } from '@/utils/misc'
import { download, parseTime, getSignTooltip } from '@/utils'
import { signFile, deleteFile, urgeSign, revokeSign, getSignUrl } from '@/api/sign'
import { uploadChildFile } from "@/api/upload"
import VuePdfPreview from "@/components/VuePdfPreview"
import UploadDialog from './upload-dialog'
import {downloadFile} from "@/api/upload"
import { fetchCustomerList } from "@/api/customer"

export default {
    components: {
        VuePdfPreview,
        UploadDialog
    },
    filters: {
        formatSize,
        parsecurrency: function (value) {
            let v = parseFloat(value).toFixed(4)
            return formatCurrency(v, 2)
        },
    },
    computed: {
    },
    data() {
        return {
            action: '',
            object_id: '',
            object_name: '',
            file_type_list: [],
            default_issue_date: '',
            default_expire_date: '',
            supplement_id: '',
            type: '',
            file_id: '',
            file_list: [],
            previewVisible: false,
            pdfname: '',
            pdfUrl: '',
            loading: false,
            loadingText: '正在加载数据，请稍等...',
            supplement: {},
            activeNames: ["1", "2", "3"],
            apply_list: [],
            attachments: [],
            outerVisible: false,
            command_options: [
                { value: 'one', label: '企业会员入会申请书' },
                { value: 'two', label: '个人会员入会申请书' },
                { value: 'three', label: '船舶入会申请书' },
                { value: 'four', label: '缴费通知书' },
                { value: 'five', label: '活动参加申请书' },
                { value: 'six', label: '互助保障活动说明书' },
                { value: 'seven', label: '互助保障活动说明书（附加4项）' }
            ],
            command_list: [],
            multipleSelection: [],
            dialogFormVisible: false,
            contacts: [],
            org_list: [],
            signer_mobile: '',
            signer_type: 0,
            signer_org_name: '',
            org_loading: false,
            file: {},
            finance_list: [],
        }
    },
    computed: {},
    methods: {
        download,
        parseTime,
        getSignTooltip,
        canSend(row) {
            let can = false
            if (row.file_sign.length == 0) {
                can = true
            }
            else if (!row.file_sign[0].receiver || row.file_sign[0].sign_flow_status === 3) {
                can = true
            }
            return can
        },
        getStatusBadge(value) {
            let badge = 'badge-dark'
            switch (value) {
                case '0':
                    badge = 'badge-secondary'
                    break
                case '1':
                    badge = 'badge-warning'
                    break
                case '2':
                    badge = 'badge-success'
                    break
                case '3':
                    badge = 'badge-danger'
                    break
                default:
                    badge = 'badge-dark'
            }

            return badge
        },
        remoteSearch(search) {
            if (search !== '') {
                this.org_loading = true
                fetchCustomerList({search: search, type: '0'})
                .then(res => {
                    this.org_list = Object.assign([], res)
                    this.org_loading = false
                })
                .catch(error => {
                    this.org_loading = false
                    this.$error_message(error)
                })
            } else {
                this.org_list = []
            }
        },
        loadData() {
            this.loading = true
            let p = []
            p.push(fetchSupplementDetail(this.supplement_id))
            p.push(fetchInsuranceObjectFileList('supplement.supplement', this.supplement_id))
            p.push(fetchAllContacts())
            Promise.all(p).then(res => {
                // console.log(res)
                this.loading = false
                this.supplement = res[0]
                this.attachments = res[1]
                this.contacts = res[2]
                this.already_num = 0
                this.signing_num = 0
                this.no_num = 0
                this.attachments.forEach(att => {
                    if (att.status === 2) {
                        this.already_num += 1
                    }
                    else if (att.status === 1) {
                        this.signing_num += 1
                    }
                    else {
                        this.no_num += 1
                    }
                })
                console.log(this.no_num)
                this.supplement.signature_status_name_detail = '已签署：' + this.already_num + ' 签署中：' + this.signing_num + ' 未签署：' + this.no_num

            }).catch(err => {
                this.loading = false
                this.$message.error(err)
            })

        },
        showDialog(row) {
            this.dialogFormVisible = true
            this.file = row
        },
        handleCancelSend() {
            this.dialogFormVisible = false
            this.signer_mobile = ''
            this.file = {}
        },
        sendSign() {
            const text = '是否发送文书' + '《' + this.file.name + '》至' + this.signer_mobile + '进行签署？'
            this.$confirm(text, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$set(this.file, 'signer_mobile', this.signer_mobile)
                this.$set(this.file, 'file_type', 'supplement.supplement')
                this.$set(this.file, 'signer_type', this.signer_type)
                this.$set(this.file, 'signer_org_name', this.signer_type === 1 ? this.signer_org_name : '')
                this.loading = true
                signFile(this.file)
                    .then(res => {
                        this.loading = false
                        // console.log(res)
                        this.$message({
                            type: 'success',
                            message: '已通知手机号为: ' + this.signer_mobile + ' 的客户进行签署'
                        });
                        this.dialogFormVisible = false
                        this.loadData()
                    })
                    .catch((err) => {
                        this.loading = false
                        this.$message.error({
                            message: err
                        });
                        this.dialogFormVisible = false
                        this.loadData()
                    })

                
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消发送签署'
                });
            });
        },
        reset_commands() {
            return [
                { value: 'one', label: '企业会员入会申请书' },
                { value: 'two', label: '个人会员入会申请书' },
                { value: 'three', label: '船舶入会申请书' },
                { value: 'four', label: '缴费通知书' },
                { value: 'five', label: '活动参加申请书' },
                { value: 'six', label: '互助保障活动说明书' },
                { value: 'seven', label: '互助保障活动说明书（附加4项）' }
            ]
        },
        handleCancel() {
            this.command_list = []
            this.outerVisible = false
        },
        handleUploadFile(param) {
            let file = param.file
            let fd = new FormData()

            fd.append("file", file)
            fd.append("object_id", this.supplement_id)
            fd.append("object_type", "supplement.supplement")
            fd.append("new_name", file.name)
            fd.append("org_file_id", this.file_id)
            // console.log(fd)
            uploadChildFile(fd)
                .then(res => {
                    param.onSuccess(res)
                    this.loadData()
                })
                .catch(error => {
                    param.onError(error)
                    error_message(error)
                })
        },
        previewPdf(file) {
            this.pdfname = file.name
            this.pdfUrl = file.url
            this.previewVisible = true
        },
        handleDelete(row) {
            this.$confirm('是否删除?', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(() => {
                this.loading = true
                deleteFile({ 'id': row.id, 'type': 'supplement.supplement' }).then(res => {
                    this.loading = false
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    })
                    this.loadData()
                }).catch(err => {
                    this.loading = false
                    this.$error_message(err)
                })
            })
        },
        handleUrgeSign(sign_id) {
            urgeSign(sign_id)
                .then(res => {
                    if (res.code === 0) {
                        this.$message({
                            type: 'success',
                            message: '已发送催签短信'
                        })
                    }
                    else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        signUrl(sign_id) {
            getSignUrl(sign_id)
            .then(res => {
                if (res.code === 0) {
                this.$alert('签署链接为：' + res.data.shortUrl)
                }
                else {
                this.$message({
                    type: 'error',
                    message: res.message
                })
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        handleRevokeSign(sign_id) {
            this.$confirm('是否撤销签署', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true
                revokeSign({'sign_id': sign_id}).then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        this.$message({
                            type: 'success',
                            message: '已撤销签署'
                        })
                        this.loadData()
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                })
                .catch(err => {
                    this.loading = false
                    console.log(err)
                })
            })
        },
        handleViewReceivable(row) {
            // this.setQueryStorage()
            this.$router.push({ name: 'ReceivableDetail', query: { id: row.id } })
        },
        handleUpload(supplement_relation, file) {
            this.object_id = file.id
            this.object_name = supplement_relation.name
            this.file_type_list = [file.file_type]
            this.$nextTick(() => {
                this.$refs.upload.handleOpen();
            })
        },
        handleDeleteFile(file) {
            this.$confirm('是否删除?', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(() => {
                this.loading = true
                deleteSupplementRelationFile(file.id).then(res => {
                    this.loading = false
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    })
                    this.loadData()
                }).catch(err => {
                    this.loading = false
                    this.$error_message(err)
                })
            })
        },
        handleDownload(file) {
            downloadFile(file.id)
            .then(res => {
                let link = document.createElement("a");
                link.style.display = "none";

                let blob = new Blob([res]);
                link.href = URL.createObjectURL(blob);

                link.download = file.name;
                document.body.appendChild(link);

                link.click();
                URL.revokeObjectURL(blob);
                document.body.removeChild(link);
            })
            .catch(error => {
                this.$error_message(error);
            });
        },
        handleAppended(fileList) {
            this.fileList = this.fileList.concat(fileList);
        },
        handleExportCommitment() {
            this.loading = true
            exportSupplementCommitment(this.supplement_id).then(res => {
                this.loading = false
                this.$message({
                    type: 'success',
                    message: '生成文书成功!'
                })
                this.loadData()
            }).catch(err => {
                console.log(err)
                this.loading = false
            })
        },
        handleCheck(value) {
            let msg = {}
            if (value) {
                msg = {
                    type: 'success',
                    message: '已同意投保单修改申请!'
                }
            }
            else {
                msg = {
                    type: 'warning',
                    message: '已拒绝投保单修改申请!'
                }
            }
            this.loading = true
            let check_data = {}
            this.$set(check_data, 'checked', value)
            checkSupplement(this.supplement_id, check_data).then(res => {
                this.loading = false
                this.$message(msg);
                this.loadData()
            }).catch(err => {
                this.loading = false
                this.$error_message(err)
            })
        }
    },
    beforeRouteLeave(to, from, next) {
        if (to.name != 'RegistList') {
            window.localStorage.removeItem('query')
        }
        next()
    },
    created() {
        // 入参处理
        if (this.$route.query.id === undefined) {
            this.$router.push('/404')
        }
        this.supplement_id = this.$route.query.id
        this.type = this.$route.query.type
        this.action = this.$route.query.action

        this.loadData()
    }
}
</script>
  
<style>
.inline-block {
    display: inline-block;
    margin-right: 10px;
}

.margin-change {
    display: inline-block;
    margin-left: 10px;
    margin-right: 10px;
}

td {
    text-align: center;
}
</style>